import { AGP_SITE } from './agp';
import { SOCIALPRENEUR_SITE } from './socialpreneur';
import type { SiteManifest } from './types';

export * from './types';
export * from './resolve';
export { AGP_SITE } from './agp';
export { SOCIALPRENEUR_SITE } from './socialpreneur';

/**
 * Every bespoke tenant site with an editable-content manifest. A NEW bespoke
 * site ships its manifest in the same PR as its `apps/member/src/tenants/<id>`
 * folder and adds one line here — the admin "Site Pages" tab then appears for
 * that tenant's build automatically (no API or editor work).
 */
export const SITE_MANIFESTS: Record<string, SiteManifest> = {
  agp: AGP_SITE,
  socialpreneur: SOCIALPRENEUR_SITE,
};

export function getSiteManifest(tenant: string | undefined | null): SiteManifest | undefined {
  return tenant ? SITE_MANIFESTS[tenant] : undefined;
}
